export default {
    date: "تاریخ",
    weight: "وزن",
    week: "هفته",
    comment: "نظر"
}